import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { APIService } from 'src/app/services/api.service';
import { NotifierService } from 'src/app/services/notifier.service';
import { getENV } from 'src/app/_helpers/helpers';
import * as moment from 'moment';

@Component({
  selector: 'app-manual-import',
  templateUrl: './manual-import.component.html',
  styleUrls: ['./manual-import.component.css']
})
export class ManualImportComponent implements OnInit {
  @Input() config: any;
  @Output() hideModel = new EventEmitter<boolean>();

  selectedApi: 'deputy' | 'risa' | 'rise' | null = null;
  loading = false;
  startDate: string = moment().format('YYYY-MM-DD');
  selectedState: string = 'vic';

  states = [
    { value: 'vic', label: 'VIC' },
    { value: 'tas', label: 'TAS' },
    { value: 'nsw', label: 'NSW' },
    { value: 'qld', label: 'QLD' },
    { value: 'sa', label: 'SA' },
    { value: 'wa', label: 'WA' }
  ];

  constructor(
    private apiService: APIService,
    private notifier: NotifierService,
  ) { }

  ngOnInit() { }

  selectApi(api: 'deputy' | 'risa' | 'rise') {
    this.selectedApi = api;
  }

  close() {
    this.hideModel.emit(false);
  }

  async triggerApi() {
    if (!this.selectedApi) return;

    this.loading = true;
    try {
      let endpoint = '';
      let payload = {};
      const formattedDate = moment(this.startDate).format('YYYY-MM-DD');

      switch (this.selectedApi) {
        case 'deputy':
          endpoint = 'deputy-trigger';
          payload = { start_date: formattedDate };
          break;
        case 'risa':
          endpoint = 'getrisa-trigger';
          break;
        case 'rise':
          endpoint = 'rise-trigger';
          payload = {
            state: this.selectedState,
            start_date: formattedDate
          };
          break;
      }

      const response = await this.apiService.postDataPromis(
        `${this.config[getENV()].raceAPI}/${endpoint}`,
        payload
      );

      if (response.status === '1') {
        this.notifier.alert('Success', '', 'API triggered successfully', 'success', 3000);
        this.hideModel.emit(true);
      } else {
        throw new Error(response.error_message || 'Failed to trigger API');
      }
    } catch (error) {
      this.notifier.alert('Error', '', error.message || 'Failed to trigger API', 'error', 5000);
    } finally {
      this.loading = false;
    }
  }
}
